import {
  AccountBalanceWallet,
  AddBusiness,
  AdminPanelSettings,
  Dashboard,
  DesignServices,
  Engineering,
  Group,
  Image,
  LocalOffer,
  Notifications,
  People,
  Person,
  Store,
  SupportAgent,
} from "@mui/icons-material";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import BookIcon from "@mui/icons-material/Book";

export const permissionCategories = [
  {
    title: "Services Management",
    icon: <DesignServices />,
    section: "services_details",
    permissions: [
      {
        key: "full_client_access",
        label: "Full Client Access",
        path: "services_details.full_client_access",
      },
      {
        key: "full_primary_access",
        label: "Full Primary Access",
        path: "services_details.full_primary_access",
      },
    ],
    subSections: [
      {
        title: "Primary Services",
        permissions: [
          {
            key: "add_services",
            label: "Add Services",
            path: "services_details.update_services_details.primary_services.add_services",
          },
          {
            key: "update_services",
            label: "Update Services",
            path: "services_details.update_services_details.primary_services.update_services",
          },
          {
            key: "inactive_active",
            label: "Activate/Deactivate Services",
            path: "services_details.update_services_details.primary_services.inactive_active",
          },
          {
            key: "view_services_list",
            label: "View Services List",
            path: "services_details.update_services_details.primary_services.view_services_list",
          },
        ],
      },
      {
        title: "Client Services",
        permissions: [
          {
            key: "add_client_service",
            label: "Add Client Service",
            path: "services_details.update_services_details.client_service.add_client_service",
          },
          {
            key: "edit_client_service",
            label: "Edit Client Service",
            path: "services_details.update_services_details.client_service.edit_client_service",
          },
          {
            key: "delete_client_service",
            label: "Delete Client Service",
            path: "services_details.update_services_details.client_service.delete_client_service",
          },
          {
            key: "view_client_service",
            label: "View Client Service",
            path: "services_details.update_services_details.client_service.view_client_service",
          },
        ],
      },
      {
        title: "Client Ticket Acceptance",
        permissions: [
          {
            key: "add_ticket_acceptance",
            label: "Add Ticket Acceptance",
            path: "services_details.update_services_details.client_service.client_ticket_acceptance.add_ticket_acceptance",
          },
          {
            key: "edit_ticket_acceptance",
            label: "Edit Ticket Acceptance",
            path: "services_details.update_services_details.client_service.client_ticket_acceptance.edit_ticket_acceptance",
          },
          {
            key: "view_ticket_acceptance",
            label: "View Ticket Acceptance",
            path: "services_details.update_services_details.client_service.client_ticket_acceptance.view_ticket_acceptance",
          },
        ],
      },
    ],
  },
  {
    title: "Notification Management",
    icon: <Notifications />,
    section: "notification_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "notification_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Notification Operations",
        permissions: [
          {
            key: "add_notification",
            label: "Add Notification",
            path: "notification_details.update_notification_details.add_notification",
          },
          {
            key: "send_notification",
            label: "Send Notification",
            path: "notification_details.update_notification_details.send_notification",
          },
          {
            key: "log_notification",
            label: "Log Notification",
            path: "notification_details.update_notification_details.log_notification",
          },
          {
            key: "active_inactive",
            label: "Activate/Deactivate",
            path: "notification_details.update_notification_details.active_inactive",
          },
          {
            key: "view_notification",
            label: "View Notification",
            path: "notification_details.update_notification_details.view_notification",
          },
        ],
      },
    ],
  },
  {
    title: "Center Management",
    icon: <AddBusiness />,
    section: "center_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "center_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Center Operations",
        permissions: [
          {
            key: "add_center",
            label: "Add Center",
            path: "center_details.update_center_details.add_center",
          },
          {
            key: "delete_center",
            label: "Delete Center",
            path: "center_details.update_center_details.delete_center",
          },
          {
            key: "update_center",
            label: "Update Center",
            path: "center_details.update_center_details.update_center",
          },
          {
            key: "view_pincode",
            label: "View Pincode",
            path: "center_details.update_center_details.view_pincode",
          },
          {
            key: "view_number",
            label: "View Contact Number",
            path: "center_details.update_center_details.view_number",
          },
          {
            key: "view_center",
            label: "View Center",
            path: "center_details.update_center_details.view_center",
          },
          {
            key: "define_capacity",
            label: "Define Capacity",
            path: "center_details.update_center_details.define_capacity",
          },
          {
            key: "authorize_client",
            label: "Authorize Client",
            path: "center_details.update_center_details.authorize_client",
          },
          {
            key: "history_center",
            label: "View Center History",
            path: "center_details.update_center_details.history_center",
          },
          {
            key: "view_documents",
            label: "View Documents",
            path: "center_details.update_center_details.view_documents",
          },
          {
            key: "download_center_list",
            label: "Download Center List",
            path: "center_details.update_center_details.download_center_list",
          },
        ],
      },
    ],
  },
  {
    title: "Ticket Management",
    icon: <SupportAgent />,
    section: "ticket_details",
    permissions: [
      {
        key: "full_normal_access",
        label: "Full Normal Access",
        path: "ticket_details.full_normal_access",
      },
    ],
    subSections: [
      {
        title: "Ticket Operations",
        permissions: [
          {
            key: "add_ticket",
            label: "Add Ticket",
            path: "ticket_details.update_ticket_details.add_ticket",
          },
          {
            key: "assigned_notassigned_ticket",
            label: "Assigned/Unassigned Tickets",
            path: "ticket_details.update_ticket_details.assigned_notassigned_ticket",
          },
          {
            key: "broadcast_ticket",
            label: "Broadcast Ticket",
            path: "ticket_details.update_ticket_details.broadcast_ticket",
          },
          {
            key: "bulk_ticket_upload",
            label: "Bulk Ticket Upload",
            path: "ticket_details.update_ticket_details.bulk_ticket_upload",
          },
          {
            key: "cancel_ticket",
            label: "Cancel Ticket",
            path: "ticket_details.update_ticket_details.cancel_ticket",
          },
          {
            key: "closed_ticket",
            label: "Closed Tickets",
            path: "ticket_details.update_ticket_details.closed_ticket",
          },
          {
            key: "delete_ticket",
            label: "Delete Ticket",
            path: "ticket_details.update_ticket_details.delete_ticket",
          },
          {
            key: "download_ticket_list",
            label: "Download Ticket List",
            path: "ticket_details.update_ticket_details.download_ticket_list",
          },
          {
            key: "part_request_ticket",
            label: "Part Request Ticket",
            path: "ticket_details.update_ticket_details.part_request_ticket",
          },
          {
            key: "part_request_ticket_list",
            label: "Part Request Ticket List",
            path: "ticket_details.update_ticket_details.part_request_ticket_list",
          },
          {
            key: "put_on_hold_ticket",
            label: "Put on Hold Ticket",
            path: "ticket_details.update_ticket_details.put_on_hold_ticket",
          },
          {
            key: "refund_ticket_amount",
            label: "Refund Ticket Amount",
            path: "ticket_details.update_ticket_details.refund_ticket_amount",
          },
          {
            key: "remark_ticket",
            label: "Remark Ticket",
            path: "ticket_details.update_ticket_details.remark_ticket",
          },
          {
            key: "specific_requirement_ticket",
            label: "Specific Requirement Tickets",
            path: "ticket_details.update_ticket_details.specific_requirement_ticket",
          },
          {
            key: "update_ticket",
            label: "Update Ticket",
            path: "ticket_details.update_ticket_details.update_ticket",
          },
          {
            key: "view_all_ticket",
            label: "View All Tickets",
            path: "ticket_details.update_ticket_details.view_all_ticket",
          },
          {
            key: "view_broadcasted_list",
            label: "View Broadcasted List",
            path: "ticket_details.update_ticket_details.view_broadcasted_list",
          },
          {
            key: "view_center_ticket",
            label: "View Center Tickets",
            path: "ticket_details.update_ticket_details.view_center_ticket",
          },
          {
            key: "view_client_ticket",
            label: "View Client Tickets",
            path: "ticket_details.update_ticket_details.view_client_ticket",
          },
          {
            key: "view_closed_ticket",
            label: "View Closed Tickets",
            path: "ticket_details.update_ticket_details.view_closed_ticket",
          },
          {
            key: "view_e_rikshaw_ticket",
            label: "View E-Rickshaw Tickets",
            path: "ticket_details.update_ticket_details.view_e_rikshaw_ticket",
          },
          {
            key: "view_no_service_ticket",
            label: "View No Service Tickets",
            path: "ticket_details.update_ticket_details.view_no_service_ticket",
          },
          {
            key: "view_normal_ticket",
            label: "View Normal Tickets",
            path: "ticket_details.update_ticket_details.view_normal_ticket",
          },
          {
            key: "view_number",
            label: "View Contact Number",
            path: "ticket_details.update_ticket_details.view_number",
          },
          {
            key: "view_pending_ticket",
            label: "View Pending Tickets",
            path: "ticket_details.update_ticket_details.view_pending_ticket",
          },
        ],
      },
    ],
  },
  {
    title: "Technician Management",
    icon: <Engineering />,
    section: "technician_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "technician_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Technician Operations",
        permissions: [
          {
            key: "add_technician",
            label: "Add Technician",
            path: "technician_details.update_technician_details.add_technician",
          },
          {
            key: "update_technician",
            label: "Update Technician",
            path: "technician_details.update_technician_details.update_technician",
          },
          {
            key: "view_document",
            label: "View Documents",
            path: "technician_details.update_technician_details.view_document",
          },
          {
            key: "delete_technician",
            label: "Delete Technician",
            path: "technician_details.update_technician_details.delete_technician",
          },
          {
            key: "authorize_client",
            label: "Authorize Client",
            path: "technician_details.update_technician_details.authorize_client",
          },
          {
            key: "view_number",
            label: "View Contact Number",
            path: "technician_details.update_technician_details.view_number",
          },
          {
            key: "view_technician",
            label: "View Technician",
            path: "technician_details.update_technician_details.view_technician",
          },
          {
            key: "download_technician_list",
            label: "Download Technician List",
            path: "technician_details.update_technician_details.download_technician_list",
          },
        ],
      },
    ],
  },
  {
    title: "Client Management",
    icon: <People />,
    section: "clients_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "clients_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Client Operations",
        permissions: [
          {
            key: "add_clients",
            label: "Add Clients",
            path: "clients_details.update_clients_details.add_clients",
          },
          {
            key: "delete_clients",
            label: "Delete Clients",
            path: "clients_details.update_clients_details.delete_clients",
          },
          {
            key: "update_clients",
            label: "Update Clients",
            path: "clients_details.update_clients_details.update_clients",
          },
          {
            key: "view_pincode",
            label: "View Pincode",
            path: "clients_details.update_clients_details.view_pincode",
          },
          {
            key: "view_clients",
            label: "View Clients",
            path: "clients_details.update_clients_details.view_clients",
          },
        ],
      },
    ],
  },
  {
    title: "Role Management",
    icon: <AdminPanelSettings />,
    section: "role_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "role_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Role Operations",
        permissions: [
          {
            key: "add_role",
            label: "Add Role",
            path: "role_details.update_role_details.add_role",
          },
          {
            key: "update_role",
            label: "Update Role",
            path: "role_details.update_role_details.update_role",
          },
          {
            key: "view_role",
            label: "View Role",
            path: "role_details.update_role_details.view_role",
          },
        ],
      },
    ],
  },
  {
    title: "User Management",
    icon: <Person />,
    section: "user_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "user_details.full_access",
      },
    ],
    subSections: [
      {
        title: "User Operations",
        permissions: [
          {
            key: "add_user",
            label: "Add User",
            path: "user_details.update_user_details.add_user",
          },
          {
            key: "update_user",
            label: "Update User",
            path: "user_details.update_user_details.update_user",
          },
          {
            key: "view_user",
            label: "View User",
            path: "user_details.update_user_details.view_user",
          },
          {
            key: "active_inactive",
            label: "Activate/Deactivate User",
            path: "user_details.update_user_details.active_inactive",
          },
        ],
      },
    ],
  },
  {
    title: "Consumer Management",
    icon: <Group />,
    section: "consumer_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "consumer_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Consumer Operations",
        permissions: [
          {
            key: "view_consumer",
            label: "View Consumer",
            path: "consumer_details.update_user_details.view_consumer",
          },
        ],
      },
    ],
  },
  {
    title: "Center Onboarding",
    icon: <Store />,
    section: "center_onboard_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "center_onboard_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Onboarding Operations",
        permissions: [
          {
            key: "add_center_onboard",
            label: "Add Center Onboard",
            path: "center_onboard_details.update_center_onboard_details.add_center_onboard",
          },
          {
            key: "update_center_onboard",
            label: "Update Center Onboard",
            path: "center_onboard_details.update_center_onboard_details.update_center_onboard",
          },
          {
            key: "view_center_onboard",
            label: "View Center Onboard",
            path: "center_onboard_details.update_center_onboard_details.view_center_onboard",
          },
        ],
      },
    ],
  },
  {
    title: "Transaction & Wallet",
    icon: <AccountBalanceWallet />,
    section: "transaction_wallet_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "transaction_wallet_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Transaction Operations",
        permissions: [
          {
            key: "view_center_transaction",
            label: "View Center Transaction",
            path: "transaction_wallet_details.update_transaction_wallet_details.view_center_transaction",
          },
          {
            key: "download_center_transaction",
            label: "Download Center Transaction",
            path: "transaction_wallet_details.update_transaction_wallet_details.download_center_transaction",
          },
          {
            key: "view_consumer_transaction",
            label: "View Consumer Transaction",
            path: "transaction_wallet_details.update_transaction_wallet_details.view_consumer_transaction",
          },
          {
            key: "download_consumer_transaction",
            label: "Download Consumer Transaction",
            path: "transaction_wallet_details.update_transaction_wallet_details.download_consumer_transaction",
          },
        ],
      },
      {
        title: "Manual Wallet Adjustment",
        permissions: [
          {
            key: "view_user_transaction",
            label: "View User Transaction",
            path: "transaction_wallet_details.update_transaction_wallet_details.view_manual_wallet_adjustment.view_user_transaction",
          },
          {
            key: "view_client_transaction",
            label: "View Client Transaction",
            path: "transaction_wallet_details.update_transaction_wallet_details.view_manual_wallet_adjustment.view_client_transaction",
          },
          {
            key: "client_recharge",
            label: "Client Recharge",
            path: "transaction_wallet_details.update_transaction_wallet_details.view_manual_wallet_adjustment.client_recharge",
          },
          {
            key: "consumer_technician_recharge",
            label: "Consumer/Technician Recharge",
            path: "transaction_wallet_details.update_transaction_wallet_details.view_manual_wallet_adjustment.consumer_technician_recharge",
          },
        ],
      },
    ],
  },
  {
    title: "Banner Management",
    icon: <Image />,
    section: "banner_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "banner_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Consumer Banner",
        permissions: [
          {
            key: "view_banner",
            label: "View Banner",
            path: "banner_details.update_banner_details.consumer_banner.view_banner",
          },
          {
            key: "active_inactive_banner",
            label: "Activate/Deactivate Banner",
            path: "banner_details.update_banner_details.consumer_banner.active_inactive_banner",
          },
          {
            key: "delete_banner",
            label: "Delete Banner",
            path: "banner_details.update_banner_details.consumer_banner.delete_banner",
          },
          {
            key: "upload_banner",
            label: "Upload Banner",
            path: "banner_details.update_banner_details.consumer_banner.upload_banner",
          },
        ],
      },
      {
        title: "Client Center Banner",
        permissions: [
          {
            key: "view_banner",
            label: "View Banner",
            path: "banner_details.update_banner_details.client_center_banner.view_banner",
          },
          {
            key: "active_inactive_banner",
            label: "Activate/Deactivate Banner",
            path: "banner_details.update_banner_details.client_center_banner.active_inactive_banner",
          },
          {
            key: "delete_banner",
            label: "Delete Banner",
            path: "banner_details.update_banner_details.client_center_banner.delete_banner",
          },
          {
            key: "upload_banner",
            label: "Upload Banner",
            path: "banner_details.update_banner_details.client_center_banner.upload_banner",
          },
        ],
      },
    ],
  },
  {
    title: "Offer & Discount",
    icon: <LocalOffer />,
    section: "offer_discount_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "offer_discount_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Offer Management",
        permissions: [
          {
            key: "add_offer",
            label: "Add Offer",
            path: "offer_discount_details.update_offer_details.offer.add_offer",
          },
          {
            key: "update_offer",
            label: "Update Offer",
            path: "offer_discount_details.update_offer_details.offer.update_offer",
          },
          {
            key: "delete_offer",
            label: "Delete Offer",
            path: "offer_discount_details.update_offer_details.offer.delete_offer",
          },
          {
            key: "active_inactive_offer",
            label: "Activate/Deactivate Offer",
            path: "offer_discount_details.update_offer_details.offer.active_inactive_offer",
          },
          {
            key: "view_offer",
            label: "View Offer",
            path: "offer_discount_details.update_offer_details.offer.view_offer",
          },
        ],
      },
      {
        title: "Discount Management",
        permissions: [
          {
            key: "add_discount",
            label: "Add Discount",
            path: "offer_discount_details.update_offer_details.discount.add_discount",
          },
          {
            key: "update_discount",
            label: "Update Discount",
            path: "offer_discount_details.update_offer_details.discount.update_discount",
          },
          {
            key: "delete_discount",
            label: "Delete Discount",
            path: "offer_discount_details.update_offer_details.discount.delete_discount",
          },
          {
            key: "active_inactive_discount",
            label: "Activate/Deactivate Discount",
            path: "offer_discount_details.update_offer_details.discount.active_inactive_discount",
          },
          {
            key: "view_discount",
            label: "View Discount",
            path: "offer_discount_details.update_offer_details.discount.view_discount",
          },
        ],
      },
    ],
  },
  {
    title: "Subscription Management",
    icon: <SubscriptionsIcon />,
    section: "subscription_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "subscription_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Subscription Operations",
        permissions: [
          {
            key: "update_subscription",
            label: "Update Subscription",
            path: "subscription_details.subscription_details.update_subscription",
          },
          {
            key: "view_subscription",
            label: "View Subscription",
            path: "subscription_details.subscription_details.view_subscription",
          },
        ],
      },
    ],
  },
  {
    title: "Blog Management",
    icon: <BookIcon />,
    section: "blog_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "blog_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Blog Operations",
        permissions: [
          {
            key: "update_blog",
            label: "Update Blog",
            path: "blog_details.blog_details.update_blog",
          },
          {
            key: "view_blog",
            label: "View Blog",
            path: "blog_details.blog_details.view_blog",
          },
          {
            key: "add_blog",
            label: "Add Blog",
            path: "blog_details.blog_details.add_blog",
          },
          {
            key: "delete_blog",
            label: "Delete Blog",
            path: "blog_details.blog_details.delete_blog",
          },
        ],
      },
    ],
  },
  {
    title: "Dashboard & Reports",
    icon: <Dashboard />,
    section: "dashboard_details",
    permissions: [
      {
        key: "full_access",
        label: "Full Access",
        path: "dashboard_details.full_access",
      },
    ],
    subSections: [
      {
        title: "Dashboard Operations",
        permissions: [
          {
            key: "view_admin_bar",
            label: "View Admin Bar",
            path: "dashboard_details.update_dashboard_details.view_admin_bar",
          },
          {
            key: "view_dashboard",
            label: "View Dashboard",
            path: "dashboard_details.update_dashboard_details.view_dashboard",
          },
          {
            key: "view_reports",
            label: "View Reports",
            path: "dashboard_details.update_dashboard_details.view_reports",
          },
          {
            key: "view_revenue",
            label: "View Revenue",
            path: "dashboard_details.update_dashboard_details.view_revenue",
          },
          {
            key: "view_performance",
            label: "View Performance",
            path: "dashboard_details.update_dashboard_details.view_performance",
          },
          {
            key: "view_audit_logs",
            label: "View Audit Logs",
            path: "dashboard_details.update_dashboard_details.view_audit_logs",
          },
        ],
      },
    ],
  },
];
